import { FC } from 'react'
import { ChatMessage } from '../../../utils/types'
import { MessageContainer, LoadingBarsContainer, LoadingBar } from '../chatArea.styles'
import MessageContent from './MessageContent'
import ResultSetTable from './ResultSetTable'
import VegaLiteChart from './VegaLiteChart'

interface ChatMessageItemProps {
  message: ChatMessage
}

const ChatMessageItem: FC<ChatMessageItemProps> = ({ message }) => {
  const isUser = message.role === 'user'

  // Get tool calls with result sets (tables)
  const toolCallsWithTables = message.toolCalls?.filter((tc) => tc.resultSet) || []

  // Get tool calls with charts
  const toolCallsWithCharts = message.toolCalls?.filter((tc) => tc.chartSpec) || []

  return (
    <MessageContainer isUser={isUser}>
      {/* Main content */}
      <MessageContent content={message.content} isUser={isUser} />

      {/* Render tool result tables */}
      {toolCallsWithTables.map(
        (toolCall) =>
          toolCall.resultSet && (
            <ResultSetTable key={toolCall.id} resultSet={toolCall.resultSet} title={toolCall.resultTitle} />
          )
      )}

      {/* Render charts from tool calls */}
      {toolCallsWithCharts.map(
        (toolCall) =>
          toolCall.chartSpec && <VegaLiteChart key={`chart-${toolCall.id}`} chartSpec={toolCall.chartSpec} />
      )}

      {/* Render standalone charts (from message history reuse) */}
      {message.charts?.map((chartSpec, index) => (
        <VegaLiteChart key={`standalone-chart-${index}`} chartSpec={chartSpec} />
      ))}

      {/* Show streaming indicator */}
      {message.status === 'streaming' && !message.content && !toolCallsWithTables.length && (
        <LoadingBarsContainer>
          <LoadingBar isActive delay={0} />
          <LoadingBar delay={100} />
          <LoadingBar delay={200} />
          <LoadingBar delay={300} />
          <LoadingBar delay={400} />
          <LoadingBar delay={500} />
        </LoadingBarsContainer>
      )}
    </MessageContainer>
  )
}

export default ChatMessageItem
